// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1X2rN","errors":"Errors_errors__1pAB5"};